import {
  makeNewFormMemoized,
  genericDeleteFunction as genericDeleteFunctionPre,
} from "./"
import {
  Operation,
  QueryArray,
  DeleteChildProps,
  BeforeRemoteMuatation,
  BeforeRemoteMuatationProps,
  OnUpdateDataMiddleWare,
  OnUpdateDataMiddleWareProps,
  ValidateForm,
  ValidateFormProps,
} from "@ml-pa/react-apollo-form-tool/formGen.model"
import React from "react"
import * as SchemaTypes from "./internal/schemaTypes"
import { FormTypes, ModifyProps } from "./internal/typeLinks"

export type ModulCreateOnUpdateDataMiddleWare =
  OnUpdateDataMiddleWare<SchemaTypes.ModulInputCreate>
export type ModulCreateOnUpdateDataMiddleWareProps =
  OnUpdateDataMiddleWareProps<SchemaTypes.ModulInputCreate>
export type ModulCreateBeforeRemoteMuatation = BeforeRemoteMuatation<
  SchemaTypes.ModulInputCreate,
  SchemaTypes.ModulInputCreateProps["injectedValues"]
>
export type ModulCreateBeforeRemoteMuatationProps = BeforeRemoteMuatationProps<
  SchemaTypes.ModulInputCreate,
  SchemaTypes.ModulInputCreateProps["injectedValues"]
>
export type ModulCreateValidateForm = ValidateForm<
  SchemaTypes.ModulInputCreate,
  SchemaTypes.ModulInputCreateProps["injectedValues"]
>
export type ModulCreateValidateFormProps = ValidateFormProps<
  SchemaTypes.ModulInputCreate,
  SchemaTypes.ModulInputCreateProps["injectedValues"]
>

export interface ModulCreateProps extends SchemaTypes.ModulInputCreateProps {
  ausbildungsArtId: number
  multiInstance?: boolean
  formVersion?: string
  onCancel?: () => void
  modifyProps?: ModifyProps<SchemaTypes.ModulInputCreate>
  afterCreate?: (data: SchemaTypes.ModulInputCreate & { id: number }) => void
  onUpdateDataMiddleWare?: OnUpdateDataMiddleWare<SchemaTypes.ModulInputCreate>
  beforeRemoteMuatation?: BeforeRemoteMuatation<
    SchemaTypes.ModulInputCreate,
    SchemaTypes.ModulInputCreateProps["injectedValues"]
  >
  validateForm?: ValidateForm<
    SchemaTypes.ModulInputCreate,
    SchemaTypes.ModulInputCreateProps["injectedValues"]
  >
  updateAfterCreateQueries?: QueryArray
}

export const ModulCreateForm: React.FC<ModulCreateProps> = (props) => {
  const {
      afterCreate,
      injectedValues,
      multiInstance = false,
      formVersion,
      onCancel,
      updateAfterCreateQueries,
      beforeRemoteMuatation,
      onUpdateDataMiddleWare,
      validateForm,
      modifyProps,
      ...params
    } = props,
    { Form: ModulCreate } = makeNewFormMemoized({
      entity: "modul",

      operation: "create",
      formVersion,
      params: multiInstance ? params : undefined,
    })
  return (
    <ModulCreate
      params={params}
      onCancel={onCancel}
      injectedValues={injectedValues}
      afterCreate={afterCreate}
      updateAfterCreateQueries={updateAfterCreateQueries}
      beforeRemoteMuatation={beforeRemoteMuatation}
      onUpdateDataMiddleWare={onUpdateDataMiddleWare}
      validateForm={validateForm}
      modifyProps={modifyProps}
    />
  )
}

export type ModulUpdateOnUpdateDataMiddleWare =
  OnUpdateDataMiddleWare<SchemaTypes.ModulInputUpdate>
export type ModulUpdateOnUpdateDataMiddleWareProps =
  OnUpdateDataMiddleWareProps<SchemaTypes.ModulInputUpdate>
export type ModulUpdateBeforeRemoteMuatation = BeforeRemoteMuatation<
  SchemaTypes.ModulInputUpdate,
  SchemaTypes.ModulInputUpdateProps["injectedValues"]
>
export type ModulUpdateBeforeRemoteMuatationProps = BeforeRemoteMuatationProps<
  SchemaTypes.ModulInputUpdate,
  SchemaTypes.ModulInputUpdateProps["injectedValues"]
>
export type ModulUpdateValidateForm = ValidateForm<
  SchemaTypes.ModulInputUpdate,
  SchemaTypes.ModulInputUpdateProps["injectedValues"]
>
export type ModulUpdateValidateFormProps = ValidateFormProps<
  SchemaTypes.ModulInputUpdate,
  SchemaTypes.ModulInputUpdateProps["injectedValues"]
>

export interface ModulUpdateProps extends SchemaTypes.ModulInputUpdateProps {
  ausbildungsArtId: number
  id: number
  multiInstance?: boolean
  formVersion?: string
  onCancel?: () => void
  modifyProps?: ModifyProps<SchemaTypes.ModulInputUpdate>
  afterUpdate?: (data: SchemaTypes.ModulInputUpdate) => void
  onUpdateDataMiddleWare?: OnUpdateDataMiddleWare<SchemaTypes.ModulInputUpdate>
  beforeRemoteMuatation?: BeforeRemoteMuatation<
    SchemaTypes.ModulInputUpdate,
    SchemaTypes.ModulInputUpdateProps["injectedValues"]
  >
  validateForm?: ValidateForm<
    SchemaTypes.ModulInputUpdate,
    SchemaTypes.ModulInputUpdateProps["injectedValues"]
  >
  fetchAllFieldsOnUpdate?: boolean
}

export const ModulUpdateForm: React.FC<ModulUpdateProps> = (props) => {
  const {
      afterUpdate,
      injectedValues,
      multiInstance = false,
      formVersion,
      onCancel,
      fetchAllFieldsOnUpdate,
      beforeRemoteMuatation,
      onUpdateDataMiddleWare,
      validateForm,
      modifyProps,
      ...params
    } = props,
    { Form: ModulUpdate } = makeNewFormMemoized({
      entity: "modul",

      operation: "update",
      formVersion,
      params: multiInstance ? params : undefined,
    })
  return (
    <ModulUpdate
      params={params}
      onCancel={onCancel}
      injectedValues={injectedValues}
      afterUpdate={afterUpdate}
      fetchAllFieldsOnUpdate={fetchAllFieldsOnUpdate}
      beforeRemoteMuatation={beforeRemoteMuatation}
      onUpdateDataMiddleWare={onUpdateDataMiddleWare}
      validateForm={validateForm}
      modifyProps={modifyProps}
    />
  )
}
